
// import React, { forwardRef, useImperativeHandle, useEffect, useRef } from "react";
// import { Howl, Howler } from "howler";
// import betchipsnd from "../../../assets/sounds/betoncard.mp3";
// import betrussiansnd from "../../../assets/sounds/bet.mp3";
// import pokerchipsnd from "../../../assets/sounds/pokerchip_snd.mp3";
// import plyerwin_snd from "../../../assets/sounds/coinBurstwinSound.mp3";
// import cardsdropping_snd from "../../../assets/sounds/carddroping.mp3";
// import cardsshuffle from "../../../assets/sounds/shuffle-cards.mp3";
// import reaveldealer_cards from "../../../assets/sounds/dealercards_reavel.mp3";
// import clear_snd from "../../../assets/sounds/clear.mp3";
// import selectCard from "../../../assets/sounds/selectcard.mp3";
// import unselectCard from "../../../assets/sounds/unselectcard.mp3";
// import playerWin from "../../../assets/sounds/successNew.mp3"
// import playerLose from "../../../assets/sounds/successNew.mp3"
// import exitSound from "../../../assets/sounds/exit.mp3"


// // SlotsSound start
// import backgroundSound from "../../../assets/SlotsSounds/backgroundCommon.mp3"
// import scatterWin from "../../../assets/SlotsSounds/scatterWin.mp3"
// import Graintwin from "../../../assets/SlotsSounds/giantWin.mp3"
// import clickbtn from "../../../assets/SlotsSounds/clickNormal.mp3"
// import spinStart from "../../../assets/SlotsSounds/spinStart.mp3"
// import spinEnd from "../../../assets/SlotsSounds/scatterReel.mp3"
// import bonusStart from "../../../assets/SlotsSounds/bonusStart.mp3"
// import bonusWin from "../../../assets/SlotsSounds/bonusWin.mp3"

// const Howlersounds = forwardRef((props, ref) => {
//   const soundsRef = useRef({});

//   useEffect(() => {
//     Howler?.mute(false);
//     Howler.volume(1);
//     Howler.autoUnlock = true;
//     Howler.autoSuspend = false;
//     soundSuspendedChecker();

//     const handleVisibilityChange = (event) => {
//       event.preventDefault();
//       soundSuspendedChecker();
//     };

//     document.addEventListener("visibilitychange", handleVisibilityChange);

//     // Initialize all sounds once
//     soundsRef.current = {
//       pokerchipsnd: new Howl({ src: [pokerchipsnd], preload: true }),
//       betchipsnd: new Howl({ src: [betrussiansnd], preload: true }),
//       playerWin: new Howl({ src: [plyerwin_snd], preload: true }),
//       playerWinbonus: new Howl({ src: [playerWin], preload: true }),
//       playerLose: new Howl({ src: [playerLose], preload: true }),
//       reavelDealerCards: new Howl({ src: [reaveldealer_cards], preload: true }),
//       selectCard: new Howl({ src: [selectCard], preload: true }),
//       unselectCard: new Howl({ src: [unselectCard], preload: true }),
//       cardShuffle: new Howl({ src: [cardsshuffle], preload: true }),
//       clearSnd: new Howl({ src: [clear_snd], preload: true }),
//       cardsdropping: new Howl({ src: [cardsdropping_snd], preload: true }),
//       exitSoundpokergames: new Howl({ src: [exitSound], preload: true }),



//       // slostSounds        start
//       backgroundSoundS: new Howl({
//         src: [backgroundSound],
//         preload: true,
//         loop: true,          // 🔥 background sound will auto-loop
//         volume: 0.3    // optional: reduce volume if needed
//       }),
//       clickbtnS: new Howl({ src: [clickbtn], preload: true }),
//       GraintwinS: new Howl({ src: [Graintwin], preload: true }),
//       scatterWinS: new Howl({ src: [scatterWin], preload: true }),
//       spinStartS: new Howl({ src: [spinStart], preload: true }),
//       spinEndS: new Howl({ src: [spinEnd], preload: true }),
//       bonusStart: new Howl({ src: [bonusStart], preload: true }),
//       bonusWin: new Howl({ src: [bonusWin], preload: true }),

//     };

//     return () => {
//       document.removeEventListener("visibilitychange", handleVisibilityChange);
//       Object.values(soundsRef.current).forEach((sound) => {
//         sound.stop();
//         sound.unload();
//       });
//     };
//   }, []);

//   // Expose playSound to parent via ref
//   useImperativeHandle(ref, () => ({
//     playSound(name) {
//       // alert("............."+props.mutesounds)
//       if (props.mutesounds) {
//         const bg = soundsRef.current["backgroundSoundS"];
//         if (bg && bg.playing()) bg.stop();
//         return;
//       }
//       if (props.mutesounds) return;
//       const sound = soundsRef.current[name];
//       if (!sound) return console.warn("Sound not found:", name);
//       // soundSuspendedChecker();
//       // // other sounds should restart normally
//       // sound.stop();
//       // sound.play();

//       if (name === "backgroundSoundS") {
//         // 🔥 If already playing, don't restart
//         if (!sound.playing()) sound.play();
//       } else {
//         soundSuspendedChecker();
//         // other sounds should restart normally
//         sound.stop();
//         sound.play();
//       }
//     },
//   }));

//   const soundSuspendedChecker = () => {
//     const tryResumeAudio = () => {
//       const ctx = Howler.ctx;
//       if (!ctx) return;

//       const state = ctx.state;
//       if (state === 'suspended' || state === 'interrupted') {
//         ctx.resume()
//           .then(() => {
//             Howler._audioUnlocked = true;
//             // console.log('✅ Howler audio resumed (state was ' + state + ')');
//           })
//           .catch(err => {
//             console.warn('⚠️ Failed to resume Howler audio:', err, 'state was', state);
//           });
//       }
//     };

//     /** 🔊 Force iOS to unlock by playing a silent buffer once */
//     const forceUnlock = () => {
//       try {
//         const buffer = Howler.ctx.createBuffer(1, 1, 22050);
//         const source = Howler.ctx.createBufferSource();
//         source.buffer = buffer;
//         source.connect(Howler.ctx.destination);
//         source.start(0);
//         source.onended = () => {
//           source.disconnect();
//           Howler._audioUnlocked = true;
//         };
//       } catch (err) {
//         console.warn('⚠️ Silent buffer unlock failed:', err);
//       }
//     };

//     // 🟢 Handle iPhone lock/unlock (page visibility + resume)
//     document.addEventListener('visibilitychange', () => {
//       if (document.visibilityState === 'visible') {
//         // console.log('🔄 Page visible again, trying to resume audio...');
//         tryResumeAudio();
//         forceUnlock(); // 🔧 ensure hardware wake-up after iPhone unlock
//       }
//     });

//     // 🟢 Handle app coming back from background
//     window.addEventListener('focus', () => {
//       // console.log('🔙 Window focus detected, resuming audio...');
//       tryResumeAudio();
//       forceUnlock();
//     });

//     // 👆 First user interaction unlocks audio
//     const unlockAudio = () => {
//       tryResumeAudio();
//       forceUnlock();
//       window.removeEventListener('touchend', unlockAudio);
//       window.removeEventListener('click', unlockAudio);
//       window.removeEventListener('touchstart', unlockAudio);
//     };

//     window.addEventListener('touchend', unlockAudio, { once: true, passive: true });
//     window.addEventListener('click', unlockAudio, { once: true, passive: true });
//     window.addEventListener('touchstart', unlockAudio, { once: true, passive: true });

//     // 🔁 Periodic safety check (every 3 sec)
//     const interval = setInterval(() => {
//       const ctx = Howler.ctx;
//       if (ctx && (ctx.state === 'suspended' || ctx.state === 'interrupted')) {
//         // console.log('⏰ Periodic resume check triggered');
//         tryResumeAudio();
//         forceUnlock();
//       }
//     }, 3000);

//     // 🧹 Optional: store interval to clear later if needed
//     window._howlerResumeInterval = interval;

//     // 🚀 Initial attempt
//     tryResumeAudio();
//     forceUnlock();
//   };

//   return null;
// });

// export default Howlersounds;







import React, { forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import { Howl, Howler } from "howler";

import betchipsnd from "../../../assets/sounds/betoncard.mp3";
import betrussiansnd from "../../../assets/sounds/bet.mp3";
import pokerchipsnd from "../../../assets/sounds/pokerchip_snd.mp3";
import plyerwin_snd from "../../../assets/sounds/coinBurstwinSound.mp3";
import cardsdropping_snd from "../../../assets/sounds/carddroping.mp3";
import cardsshuffle from "../../../assets/sounds/shuffle-cards.mp3";
import reaveldealer_cards from "../../../assets/sounds/dealercards_reavel.mp3";
import clear_snd from "../../../assets/sounds/clear.mp3";
import selectCard from "../../../assets/sounds/selectcard.mp3";
import unselectCard from "../../../assets/sounds/unselectcard.mp3";
import playerWin from "../../../assets/sounds/successNew.mp3";
import playerLose from "../../../assets/sounds/successNew.mp3";
import exitSound from "../../../assets/sounds/exit.mp3";

// SlotsSound start
import backgroundSound from "../../../assets/SlotsSounds/backgroundCommon.mp3";
import scatterWin from "../../../assets/SlotsSounds/scatterWin.mp3";
import Graintwin from "../../../assets/SlotsSounds/giantWin.mp3";
import clickbtn from "../../../assets/SlotsSounds/clickNormal.mp3";
import spinStart from "../../../assets/SlotsSounds/spinStart.mp3";
import spinEnd from "../../../assets/SlotsSounds/scatterReel.mp3";
import bonusStart from "../../../assets/SlotsSounds/bonusStart.mp3";
import bonusWin from "../../../assets/SlotsSounds/bonusWin.mp3";

const Howlersounds = forwardRef((props, ref) => {
  const soundsRef = useRef({});

  useEffect(() => {
    Howler.mute(false);
    Howler.volume(1);
    Howler.autoUnlock = true;
    Howler.autoSuspend = false;

    soundSuspendedChecker();

    /** -------------------------------------------------------------
     *  🔥 PHONE LOCK / UNLOCK — MAIN FIX
     *  When phone is locked → stop all sound.
     *  When unlocked → resume ONLY background.
     * ------------------------------------------------------------- */
    // Initialize all sounds
    soundsRef.current = {
      pokerchipsnd: new Howl({ src: [pokerchipsnd], preload: true }),
      betchipsnd: new Howl({ src: [betrussiansnd], preload: true }),
      playerWin: new Howl({ src: [plyerwin_snd], preload: true }),
      playerWinbonus: new Howl({ src: [playerWin], preload: true }),
      playerLose: new Howl({ src: [playerLose], preload: true }),
      reavelDealerCards: new Howl({ src: [reaveldealer_cards], preload: true }),
      selectCard: new Howl({ src: [selectCard], preload: true }),
      unselectCard: new Howl({ src: [unselectCard], preload: true }),
      cardShuffle: new Howl({ src: [cardsshuffle], preload: true }),
      clearSnd: new Howl({ src: [clear_snd], preload: true }),
      cardsdropping: new Howl({ src: [cardsdropping_snd], preload: true }),
      exitSoundpokergames: new Howl({ src: [exitSound], preload: true }),

      // slot sounds
      backgroundSoundS: new Howl({
        src: [backgroundSound],
        preload: true,
        loop: true,
        volume: 0.3,
      }),
      clickbtnS: new Howl({ src: [clickbtn], preload: true }),
      GraintwinS: new Howl({ src: [Graintwin], preload: true }),
      scatterWinS: new Howl({ src: [scatterWin], preload: true }),
      spinStartS: new Howl({ src: [spinStart], preload: true }),
      spinEndS: new Howl({ src: [spinEnd], preload: true }),
      bonusStart: new Howl({ src: [bonusStart], preload: true }),
      bonusWin: new Howl({ src: [bonusWin], preload: true }),
    };

    const handleVisibility = () => {
      const bg = soundsRef.current["backgroundSoundS"];
      // alert("In Handle Visibility " + document.visibilityState)
      if (document.visibilityState === "hidden") {
        Object.values(soundsRef.current).forEach((s) => s.stop());
      } else if (document.visibilityState === "visible") {

        const ctx = Howler.ctx;
        // alert("In Handle Hidden " + /iphone|ipad|ipod/i.test(navigator.userAgent))
        // Android can auto-play
        // if (!/iphone|ipad|ipod/i.test(navigator.userAgent)) {
        // alert("In Iphone " + ctx.state)
        if (ctx.state === "suspended" || ctx.state === "interrupted") {
          ctx.resume().then(() => {
            // if (bg && !bg.playing()) bg.play();
            bg.stop()
            bg.play()

          });
        } else {
          bg.stop()
          bg.play()
        }
        //   return;
        // }

        // iOS requires user interaction to unlock audio
        const resumeOnTap = () => {
          // alert("In Resume Tap " + ctx.state)
          if (ctx.state === "suspended" || ctx.state === "interrupted") ctx.resume().then(() => {
            // if (bg && !bg.playing()) bg.play();
            // alert(bg)
            bg.stop()
            bg.play()

          });

          window.removeEventListener("touchstart", resumeOnTap);
          window.removeEventListener("click", resumeOnTap);
        };

        window.addEventListener("touchstart", resumeOnTap, { once: true });
        window.addEventListener("click", resumeOnTap, { once: true });
      }
    };


    document.addEventListener("visibilitychange", handleVisibility);
    document.addEventListener("pagehide", handleVisibility);
    document.addEventListener("pageshow", handleVisibility);



    return () => {
      document.removeEventListener("visibilitychange", handleVisibility);
      document.removeEventListener("pagehide", handleVisibility);
      document.removeEventListener("pageshow", handleVisibility);
      Object.values(soundsRef.current).forEach((sound) => {
        sound.stop();
        sound.unload();
      });
    };
  }, []);

  /** ------------------------------------------------------------------
   *          PUBLIC FUNCTION FOR PLAYING SOUND (parent calls)
   * ------------------------------------------------------------------ */
  useImperativeHandle(ref, () => ({
    playSound(name) {
      if (props.mutesounds) {
        const bg = soundsRef.current["backgroundSoundS"];
        if (bg && bg.playing()) bg.stop();
        return;
      }

      const sound = soundsRef.current[name];
      if (!sound) return console.warn("Sound not found:", name);

      if (name === "backgroundSoundS") {
        if (!sound.playing()) sound.play();
      } else {
        soundSuspendedChecker();
        sound.stop();
        sound.play();
      }
    },
  }));

  /** ------------------------------------------------------------------
   *        iOS unlock audio context helper
   * ------------------------------------------------------------------ */
  const soundSuspendedChecker = () => {
    const tryResumeAudio = () => {
      const ctx = Howler.ctx;
      if (!ctx) return;

      if (ctx.state === "suspended" || ctx.state === "interrupted") {
        ctx.resume().catch(() => { });
      }
    };

    const forceUnlock = () => {
      try {
        const buffer = Howler.ctx.createBuffer(1, 1, 22050);
        const source = Howler.ctx.createBufferSource();
        source.buffer = buffer;
        source.connect(Howler.ctx.destination);
        source.start(0);
        source.onended = () => source.disconnect();
      } catch (err) { }
    };

    // First interaction unlock
    const unlockAudio = () => {
      tryResumeAudio();
      forceUnlock();
      window.removeEventListener("touchend", unlockAudio);
      window.removeEventListener("click", unlockAudio);
      window.removeEventListener("touchstart", unlockAudio);
    };

    window.addEventListener("touchend", unlockAudio, { once: true });
    window.addEventListener("click", unlockAudio, { once: true });
    window.addEventListener("touchstart", unlockAudio, { once: true });

    // periodic check
    setInterval(() => {
      const ctx = Howler.ctx;
      if (ctx && (ctx.state === "suspended" || ctx.state === "interrupted")) {
        tryResumeAudio();
        forceUnlock();
      }
    }, 3000);

    tryResumeAudio();
    forceUnlock();
  };

  return null;
});

export default Howlersounds;
